import { HttpParams } from '@angular/common/http';
import { CryptoUtil } from './crypto.utils';

export const getEncodedResetPasswordUrl = (): string =>
  CryptoUtil.base64Encode(`${window.location.origin}/auth/change-password`);

interface BuildHttpParamsOptions {
  serializeObjects?: boolean;
}

export const buildHttpParams = (
  payload: object | null | undefined,
  options: BuildHttpParamsOptions = {},
): HttpParams => {
  const { serializeObjects = true } = options;
  let params = new HttpParams();

  Object.entries((payload ?? {}) as Record<string, unknown>).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return;
      }

      const hasObjectItems = value.some((item) => item !== null && typeof item === 'object');
      if (hasObjectItems && serializeObjects) {
        params = params.set(key, JSON.stringify(value));
        return;
      }

      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== '') {
          params = params.append(key, String(item));
        }
      });
      return;
    }

    if (typeof value === 'object') {
      if (!serializeObjects) {
        return;
      }
      params = params.set(key, JSON.stringify(value));
      return;
    }

    params = params.set(key, String(value));
  });

  return params;
};


